import { FC, memo, useState } from 'react';
import { FileOutlined } from '@ant-design/icons';
import * as Styled from './styles';
import * as StyledShared from '../../styles';
import { isImage } from 'utils/isImage';
import type { UploadFile } from 'antd/es/upload/interface';

type MultipleFileListItemProps = {
  file: UploadFile;
  handleDelete?: (file: UploadFile) => void;
  showTrash?: boolean;
};

export const MultipleFileListItem: FC<MultipleFileListItemProps> = memo(
  ({ file, handleDelete, showTrash = true }) => {
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);

    return (
      <Styled.MultiFileWrapper key={file.uid}>
        {isImage(file.type || '') ? (
          <Styled.FileImage
            src={file.preview}
            alt={file.name}
            preview={{
              visible: isPreviewOpen,
              onVisibleChange: visible => setIsPreviewOpen(visible)
            }}
          />
        ) : (
          <FileOutlined />
        )}
        <Styled.OverlayWrapper>
          <Styled.FileName>{file.name}</Styled.FileName>
          <Styled.RightWrapper>
            {isImage(file.type || '') && (
              <StyledShared.PreviewIcon
                $darkTheme
                onClick={() => setIsPreviewOpen(true)}
              />
            )}
            {showTrash && (
              <Styled.TrashIcon onClick={() => handleDelete?.(file)} />
            )}
          </Styled.RightWrapper>
        </Styled.OverlayWrapper>
      </Styled.MultiFileWrapper>
    );
  }
);
